// US retention defaults per state (plan §7, research: compliance). Days of pickup records a site
// keeps at minimum; sites may keep longer, never shorter. CACFP participation adds 3 years plus
// the current fiscal year regardless of state.
export interface RetentionRule { days: number; source: string }

export const DEFAULT_RETENTION_DAYS = 365;

export const STATE_RETENTION: Record<string, RetentionRule> = {
  CA: { days: 31, source: "22 CCR §101229.1(c): sign-in/out sheets kept one month" },
  TX: { days: 92, source: "26 TAC §746.603: child records kept 3 months after the child's last day" },
  FL: { days: 123, source: "FAC 65C-22.001(6): attendance kept 4 months minimum" },
  IL: { days: 365, source: "89 Ill. Adm. Code 407.250/407.260: attendance kept 1 year" },
};

export const CACFP_DAYS = 3 * 365 + 366;
export const TX_PUBLIC_SCHOOL_DAYS = 5 * 365 + 1;

export function retentionDays(opts: { state: string; cacfp?: boolean; txPublicSchool?: boolean; plan?: "door" | "school" | "district" }): number {
  const base = Math.max(STATE_RETENTION[opts.state]?.days ?? 0, DEFAULT_RETENTION_DAYS);
  const plan = opts.plan === "school" || opts.plan === "district" ? 5 * 365 + 1 : 0;
  return Math.max(base, plan, opts.cacfp ? CACFP_DAYS : 0, opts.txPublicSchool ? TX_PUBLIC_SCHOOL_DAYS : 0);
}

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN",
  "MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA",
  "WV","WI","WY",
] as const;
